import { createReduxAsyncThunk } from 'shared/utils';
import { reduceAsync } from 'common/utils';

import dataSources from 'dataSources';

import { STATIONS_STATE } from '../../constants';

import { StationWithPrices, StationsWithPricesMap } from '../../types';
import { RoutesStations } from 'common/context/routes/types/routesStations';

interface Result {
  stationsWithPrices: StationWithPrices[];
  stationsWithPricesMap: StationsWithPricesMap;
}

export const getStationsWithPricesByCodes = createReduxAsyncThunk<Result, RoutesStations>(
  `${STATIONS_STATE}/getStationsWithPrices`,
  async (routerStations: RoutesStations) => {
    const stationCodes = Object.values(routerStations).reduce((acc, routStations) => {
        routStations.forEach((station) => acc.push(station.code));
        return acc
    }, [] as string[])

    const stationsWithPricesPromise = await dataSources.stations.getStationsPrices(stationCodes);

    const stationsWithPrices: StationWithPrices[] = stationsWithPricesPromise.map((station) => {
        return {
            code: station.stationInternalId,
            servicePrices: station.services
        };
    });
    const stationsWithPricesMap = await reduceAsync<StationWithPrices, StationsWithPricesMap>(
      stationsWithPrices,
      (acc, stationWithPrices) => {
        acc[stationWithPrices.code] = stationWithPrices;
        return acc;
      }, {}
    );

    return {
      stationsWithPrices,
      stationsWithPricesMap
    };
  }
);

export {}